import * as React from 'react';
import { useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { VisibilityIcon as Visibility, VisibilityOffIcon as VisibilityOff } from "../../../icons";
import { FieldLabelWithHelp } from "./FieldHelpIcon";

type InputSecretProps = {
  label: string;
  value: string;
  helperText?: string;
  error?: boolean;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  customWidth?: number;
  disabled?: boolean;
  hidden?: boolean;
  description?: string;
};

export const InputSecret: React.FC<InputSecretProps> = ({
  label,
  value,
  onChange,
  helperText = "",
  error = false,
  autoFocus = false,
  customWidth = 500,
  disabled = false,
  hidden = false,
  description,
}) => {
  const [showValue, setShowValue] = useState(false);

  const handleClickShowValue = () => {
    setShowValue(!showValue);
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  if (hidden) return null;

  return (
    <TextField
      disabled={disabled}
      autoFocus={autoFocus}
      size="small"
      type={showValue ? "text" : "password"}
      inputProps={{ autoComplete: "one-time-code" }}
      error={error}
      helperText={helperText}
      sx={{ m: 1, mb: 1.5, width: customWidth }}
      label={<FieldLabelWithHelp label={label} description={description} />}
      InputLabelProps={description ? { shrink: true } : undefined}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle visibility"
              onClick={handleClickShowValue}
              onMouseDown={handleMouseDown}
              edge="end"
              size="small"
            >
              {showValue ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
